import Force0 from "assets/images/Force0.png";
import Force1 from "assets/images/Force1.png";
import Force2 from "assets/images/Force2.png";
import Force3 from "assets/images/Force3.png";
import Force4 from "assets/images/Force4.png";
import Force5 from "assets/images/Force5.png";
import Force6 from "assets/images/Force6.png";
import Force7 from "assets/images/Force7.png";
import Force8 from "assets/images/Force8.png";
import Force9 from "assets/images/Force9.png";
import Force10 from "assets/images/Force10.png";
import Force11 from "assets/images/Force11.png";
import Force12 from "assets/images/Force12.png";

export const WIND_NAME_DICT = Object.freeze({
    1: "Bora",
    2: "Grecale",
    3: "Schiavo",
    4: "Levante",
    5: "Solano",
    6: "Scirocco",
    7: "Africo",
    8: "Ostro",
    9: "Gauro",
    10: "Libeccio",
    11: "Etesia",
    12: "Ponente",
    13: "Traversone",
    14: "Maestrale",
    15: "Zefiro",
    0: "Tramontana",
});

export const WIND_DIRECTION_DICT = Object.freeze({
    1: "NNE",
    2: "NE",
    3: "ENE",
    4: "E",
    5: "ESE",
    6: "SE",
    7: "SSE",
    8: "S",
    9: "SSW",
    10: "SW",
    11: "WSW",
    12: "W",
    13: "WNW",
    14: "NW",
    15: "NNW",
    0: "N",
});
export const WIND_DIRECTION_DICT360 = Object.freeze({
    0: "N",
    22.5: "NNE",
    45: "NE",
    67.5: "ENE",
    90: "E",
    112.5: "ESE",
    135: "SE",
    157.5: "SSE",
    180: "S",
    202.5: "SSW",
    225: "SW",
    247.5: "WSW",
    270: "W",
    292.5: "WNW",
    315: "NW",
    337.5: "NNW",

});

export const getIconWindDirection = (value) => {
    switch (value) {
        case 0:
            return "↓"; //N
        case 1:
            return "↙"; //NNE
        case 2:
            return "↙"; //NE
        case 3:
            return "↙"; //ENE
        case 4:
            return "←"; //E
        case 5:
            return "↖"; //ESE
        case 6:
            return "↖"; //SE
        case 7:
            return "↖"; //SSE
        case 8:
            return "↑"; //S
        case 9:
            return "↗"; //SSW
        case 10:
            return "↗"; //SW
        case 11:
            return "↗"; //WSW
        case 12:
            return "→"; //W
        case 13:
            return "↘"; //WNW
        case 14:
            return "↘"; //NW
        case 15:
            return "↘"; //NNW
        default:
            return "";
    }
};

export const getWindForce = (value) => {
    if (value >= 0 && value < 1) return <img width={20} src={Force0} alt="img wind force" />;
    if (value >= 1 && value <= 6)
        return <img width={20} src={Force1} alt="img wind force" />;
    if (value >= 7 && value <= 11)
        return <img width={20} src={Force2} alt="img wind force" />;
    if (value >= 12 && value <= 19)
        return <img width={20} src={Force3} alt="img wind force" />;
    if (value >= 20 && value <= 29)
        return <img width={20} src={Force4} alt="img wind force" />;
    if (value >= 30 && value <= 39)
        return <img width={20} src={Force5} alt="img wind force" />;
    if (value >= 40 && value <= 50)
        return <img width={20} src={Force6} alt="img wind force" />;
    if (value >= 51 && value <= 62)
        return <img width={20} src={Force7} alt="img wind force" />;
    if (value >= 63 && value <= 75)
        return <img width={20} src={Force8} alt="img wind force" />;
    if (value >= 76 && value <= 87)
        return <img width={20} src={Force9} alt="img wind force" />;
    if (value >= 88 && value <= 102)
        return <img width={25} src={Force10} alt="img wind force" />;
    if (value >= 103 && value <= 117)
        return <img width={25} src={Force11} alt="img wind force" />;
    if (value > 117) return <img width={25} src={Force12} alt="img wind force" />;
};